/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';

export default {
    login,
    registerToken,
    GetAvailableNotification,
    NotificationMarkAsRead
};

async function login(data) {
    const body = {
        username: data.username,
        password: data.password
    }
    const response = await CommonPost('/api/auth/login', null, body);
    return response;
}

async function registerToken(token) {
    const body = {
        token: token,
        userID: parseInt(TokenDecoder.getUserIDFromToken())
    }
    const response = await CommonPost('/api/PushNotification/RegisterToken', null, body);
    return response;
}

async function GetAvailableNotification() {
    const response = await CommonGet('/api/PushNotification/GetAvailableNotification', 'userID=' + parseInt(TokenDecoder.getUserIDFromToken()));
    return response.data;
}

async function NotificationMarkAsRead(body) {
    const response = await CommonPost('/api/PushNotification/NotificationMarkAsRead', null, body);
    return response;
}